/**
 * Map tempo (BPM) to normalised slider value in [0, 1].
 * low → 0, base (100%) → 0.5, high → 1. Piecewise linear.
 */
export function tempoToSlider(tempo: number, low: number, base: number, high: number): number {
  const t = Math.max(low, Math.min(high, tempo));
  if (base - low <= 0) return t <= base ? 0 : 1;
  if (high - base <= 0) return t >= base ? 1 : 0;
  if (t <= base) return (0.5 * (t - low)) / (base - low);
  return 0.5 + (0.5 * (t - base)) / (high - base);
}

/**
 * Map normalised slider value in [0, 1] to tempo (BPM). Result clamped to [low, high].
 */
export function sliderToTempo(s: number, low: number, base: number, high: number): number {
  const x = Math.max(0, Math.min(1, s));
  if (base - low <= 0 || high - base <= 0) return low + (high - low) * x;
  let tempo: number;
  if (x <= 0.5) tempo = low + (base - low) * (x / 0.5);
  else tempo = base + (high - base) * ((x - 0.5) / 0.5);
  return Math.max(low, Math.min(high, tempo));
}

export function sliderToTempoPercentage(
  s: number,
  low: number,
  base: number,
  high: number,
): number {
  return (sliderToTempo(s, low, base, high) / base) * 100;
}
